import { useState } from 'react';

import { toast } from 'react-toastify';
import styled from 'styled-components';

import { TotemInput } from 'components/TotemInput';
import { TotemPopup } from 'components/TotemPopup';
import { TotemPrimaryLoadingButton } from 'components/TotemPrimaryLoadingButton';

import { productArrangementsUpdatedOrCreatedHandler } from '../cacheHandlers/productArrangementsCacheHandler';

import { useCreateProductArrangementMutation } from 'data/__generated__';

export function CreateProductArrangementPopup({
    isOpen,
    setIsOpen,
}: {
    isOpen: boolean;
    setIsOpen: (arg: boolean) => void;
}) {
    const [productArrangementName, setProductArrangementName] = useState<string>('');

    const [createProductArrangement, { loading: creationLoading }] = useCreateProductArrangementMutation({
        variables: { name: productArrangementName },
    });

    async function handleSubmit() {
        const { data } = await createProductArrangement();

        if (!data) {
            throw new Error('Une erreur est survenue lors de la creation de la gamme de produit');
        }

        const {
            createProductArrangementMutation: { newProductArrangement, errors },
        } = data;

        if (errors.length) {
            errors.forEach((error, index) => {
                toast.error(<span key={index}>Erreur : {error}</span>, { autoClose: false });
            });

            if (errors.length > 1) {
                toast.info('Cliquez pour fermer toutes les notifications', {
                    autoClose: false,
                    onClick: () => toast.dismiss(),
                });
            }
        }

        if (newProductArrangement) {
            productArrangementsUpdatedOrCreatedHandler([newProductArrangement]);

            const newWindow = window.open(
                `product-arrangement/${newProductArrangement._id}`,
                '_blank',
                'noopener,noreferrer',
            );
            if (newWindow) {
                newWindow.opener = null;
            }
        }

        setIsOpen(false);
    }

    return (
        <TotemPopup title="Créer une gamme de produit" isOpen={isOpen} setIsOpen={setIsOpen} contentOverflow="visible">
            Veuillez donner un nom unique à votre gamme de produit
            <SubmitContainer>
                <TotemInput
                    label="Nom de la gamme de produit"
                    onChange={setProductArrangementName}
                    placeholder="Dessert Bergam laitier"
                    value={productArrangementName}
                    autoFocus
                />
                <ValidationButton onClick={handleSubmit} loading={creationLoading} useIcon={false} label="Confirmer" />
            </SubmitContainer>
        </TotemPopup>
    );
}

const SubmitContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 15px;
`;

const ValidationButton = styled(TotemPrimaryLoadingButton)`
    margin-top: 15px;
`;
